import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../../colors';

export const useStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
  },
  subHeader: {
    display: 'flex',
    padding: '24px',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    borderTop: `1px solid ${colors.neutral100}`,
    backgroundColor: colors.neutral25,
  },
  produreContainer: {
    border: `1px solid ${colors.neutral100}`,
    borderRadius: '12px !important',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.04)',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    minWidth: 680,
    width: '100%',
    backgroundColor: colors.white,
  },
  printBtn: {
    height: '38px !important',
    borderColor: colors.primary300,
    padding: '19px 12px !important',
  },
  saveAsPdfBtn: {
    color: 'white !important',
    height: '40px !important',
  },
  header: {
    padding: 24,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    color: colors.neutral900,
    alignItems: 'center',
  },
  body: {
    borderTop: `1px solid ${colors.neutral100}`,
    borderBottom: `1px solid ${colors.neutral100}`,
    padding: 24,
  },
  bodyUuid: {
    fontWeight: 400,
    fontSize: 36,
    lineHeight: '44px',
    color: colors.neutral900,
    fontfamily: 'Source Serif Pro',
  },
  bodyServiceName: {
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    color: colors.neutral900,
    fontfamily: 'Source Serif Pro',
  },
  editBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    width: '100%',
    height: 20,
    color: colors.primary500,
    display: 'flex',
    padding: 0,
    minWidth: 'fit-content',
    gap: 8,
    '& svg': {
      width: 18,
      height: 18,
    },
  },
  checkIcon: {
    width: 17,
    height: 17,
    '& path': {
      fill: colors.primary500,
    },
  },
  modalitiesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  modalitiesListItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '24px',
    color: colors.neutral700,
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'center',
    fontSize: 14,
  },
  dateWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'center',
    fontSize: 14,
    marginRight: '8px',
  },
  subtitleWrapper: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '24px',
    color: colors.neutral700,
  },
  planCardSubtitle: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
    color: colors.neutral900,
  },
  planCardText: {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
    color: colors.neutral700,
  },
  subText: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.neutral600,
  },
  menu: {
    '& svg': {
      width: 16,
      '& path': {
        fill: colors.primary500,
      },
    },
  },
  menuButton: {
    display: 'flex',
    width: '40px',
    height: '40px',
    padding: '8px 12px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    border: `1px solid ${colors.neutral300}`,
    backgroundColor: colors.white,
    '& svg': {
      width: 16,
      marginLeft: '0px !important',
    },
  },
  menuItemsWrapper: {
    '& ul li': {
      padding: '10px 16px',
    },
  },
  textSuccess: {
    color: colors.success600,
  },
  textError: {
    color: colors.destructive600,
  },
  plancardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    borderTop: `1px solid ${colors.neutral100}`,
    padding: 24,
  },
  objectivesListItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral700,
  },
  objective: {
    background: colors.primary50,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    borderRadius: 8,
    padding: 24,
  },
  objectivesCheckIcon: {
    width: 16,
    height: 16,
    minWidth: 16,
    '& path': {
      fill: colors.primary500,
    },
  },
  objectiveTile: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral700,
  },
  visitFrequency: {
    width: 24,
    height: 24,
  },
  badge: {
    borderRadius: 100,
    height: 18,
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 600,
    minWidth: '15%',
  },
  warningBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    padding: '16px',
    borderRadius: '8px',
    backgroundColor: colors.white,
    border: `1px solid ${colors.indigo300}`,
    maxHeight: '72px',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    color: colors.neutral700,
  },
  iconSize: {
    width: '20px',
    height: '20px',
  },
  bold: {
    fontWeight: 700,
  },
  warningBoxContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  backBtn: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    color: colors.primary600,
    maxHeight: '20px',
    maxWidth: '120px',
    padding: '0px !important',
  },
});
